import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapperModal: ({ spacing }) => css`
    p {
      margin: ${spacing.xs} 0 ${spacing.md} 0;
    }
  `,
})

export { useStyles }
